import React, {  useEffect } from "react";
import { connect } from "react-redux";

import { Grid, Paper } from "@material-ui/core";
import useStyles from "./styles";

import { Typography } from "../../components/Wrappers/Wrapper";
import Dot from "../../components/Sidebar/components/Dot";

//store
import * as actions from "../../store/actions/actionIndex";

function StatusBar(props) {
	let Login = 0.0,
		Break = 0.0,
		Remaining = 100.0;

	props.statusData.map((data) => {
		if (data.name === "Login Time" && data.value) {
			let time = data.value.split(":");
			let timeVar = parseInt(time[2]) + parseInt(time[1]) * 60 + parseInt(time[0]) * 3600;
			let timeVal = (parseFloat(timeVar) / 864).toFixed(2);
			Login = timeVal;
		}
		if (data.name === "Ready Time" || data.name === "Break Time") {
			let time = data.value.split(":");
			let timeVar = parseInt(time[2]) + parseInt(time[1]) * 60 + parseInt(time[0]) * 3600;
			let timeVal = (parseFloat(timeVar) / 864).toFixed(2);
			Break = timeVal;
		}
		return true;
	});
	Remaining = Remaining - Login - Break;

	let readings = [
		{ name: "Login", value: Login, color: "#3cd4a0" },
		{ name: "Break", value: Break, color: "#ffc260" },
		{ name: "Remaining", value: Remaining, color: "#ddd" },
	];

	let bars =
		readings &&
		readings.length &&
		readings.map((item, i) => {
			if (item.value > 0) {
				return <div className="bar" style={{ backgroundColor: item.color, width: item.value + "%", float: "left", height: "4px" }} key={i}></div>;
			}
			return <div key={i} />;
		});

	return <div>{bars === "" ? "" : bars}</div>;
}

function AgentProgressBar(props) {
	var classes = useStyles();


	const { agentId, onBreakReason } = props;
	useEffect(() => {
		onBreakReason(agentId);
	}, [agentId, onBreakReason]);

	

	return (
		<div>
			<Grid item md={false} sm={false} xs={12}>
				<Paper className={classes.ToggleBar}>
					<div className={classes.RemainingWork}>Today work hours</div>
					<div className={classes.progressSection}>
						<StatusBar statusData={props.statusData} />
					</div>

					<div className={classes.performanceLegendWrapper}>
						<div className={classes.legendElement}>
							<Dot color="success" />
							<Typography color="text-white" colorBrightness="secondary" className={classes.legendElementText}>
								Login Time
							</Typography>
						</div>
						<div className={classes.legendElement}>
							<Dot color="warning" />
							<Typography color="text-white" colorBrightness="secondary" className={classes.legendElementText}>
								Total Break Time
							</Typography>
						</div>
					</div>
				</Paper>
			</Grid>
		</div>
	);
}

const mapStateToProps = (state) => {
	return {
		agentState: state.agentData.agentState,
		breakReasons: state.breakReason.breakReasons,
		loading: state.breakReason.loading,
		error: state.breakReason.error,
		agentId: state.agentData.agentId,
		statusData: state.callData.posts,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onBreakReason: (agentId) => dispatch(actions.breakReason(agentId)),
		onAgentBreak: (agentId, breakState, breakType) => dispatch(actions.agentBreak(agentId, breakState, breakType)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(AgentProgressBar);
